"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.tooltips.talk': 'Inizia conversazione con questo avatar',
    'avatar.tooltips.preview': 'Anteprima dettagli avatar',
    'avatar.tooltips.edit': 'Modifica impostazioni avatar',
    'avatar.tooltips.delete': 'Elimina questo avatar',
};
